export default __webpack_public_path__ + "badb98080214485db486794fb59a95cc.svg";